import React from 'react';
import { OrganicoIstitutoDTO } from '../../../api/employee/schemas';
import { SiapDataTable } from './components/SiapDataTable';

const SiapDataPreviewFixture: OrganicoIstitutoDTO = {
  dataRiferimento: '2020-01-01T10:32:11.000Z',
  codAoo: 'abcd-1234',
  istituto: 'Lorem Ipsum',
  regione: 'Maecenas',
  profili: [
    {
      carenzaEccedenza: 10,
      organicoFatto: 100,
      organicoDiritto: 90,
      profiloDm: 'Profilo 1',
    },
    {
      carenzaEccedenza: -5,
      organicoFatto: 100,
      organicoDiritto: 105,
      profiloDm: 'Profilo 2',
    },
  ],
};

export interface ISiapDataPreviewComponentProps {}

export function SiapDataPreviewComponent(
  props: ISiapDataPreviewComponentProps,
) {
  return <SiapDataTable data={SiapDataPreviewFixture} />;
}
